import React from 'react';
import { IconButton } from '@telus-uds/components-web';
import DeleteIcon from '@telus-uds/palette-allium/build/web/icons/Delete';
import { getLocale } from '../../../misc';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';
import { Td, Th } from './css';
import { formatCurrency } from '../../../utils/currencyFormatter';
import { calculateCharges } from './utils';

const tableForCouponCodeOffer = ({
  selectedCouponData = {},
  setSelectedCouponData,
  setIsFormTouched,
  setShowDownloadQuoteFooter
}) => {
  const { data = [], monthlyCharges = 0, oneTimeCharges = 0 } = selectedCouponData;
  if (data.length === 0) return null;

  const deleteItem = (e, idx) => {
    if (e && e.preventDefault) e.preventDefault();

    // Pass the computed NEXT VALUE directly rather than a React-style
    // updater function — `setSelectedCouponData` is `form.setValue` (the
    // forms-core engine) once wired through the section registry, which
    // assigns whatever it's given as the new value verbatim rather than
    // calling it. An updater function was being stored as the field's
    // value itself, and the table (reading `.data` off a function) rendered
    // as if every offer had been removed.
    const newData = data.filter((_, i) => i !== idx);
    const { monthlyChargesPrice, oneTimeChargesPrice } = calculateCharges(
      newData
    );
    setSelectedCouponData({
      ...selectedCouponData,
      data: newData,
      monthlyCharges: monthlyChargesPrice,
      oneTimeCharges: oneTimeChargesPrice
    });
    setIsFormTouched(true);
    setShowDownloadQuoteFooter(false);
  };

  const locale = getLocale();
  const {
    vulcanWebform: {
      offerCode,
      offerDescription,
      offerDetails,
      monthlyChargesColumn,
      oneTimeChargeColumn,
      actions
    }
  } = locale === 'en-US' ? EN : FR;
  return (
    <>
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginTop: '20px'
        }}
      >
        <tr style={{ height: '60px' }}>
          <Th>{offerCode}</Th>
          {/* <Th>{offerDescription}</Th> */}
          <Th>{offerDetails}</Th>
          <Th>{monthlyChargesColumn}</Th>
          <Th>{oneTimeChargeColumn}</Th>
          <Th>{actions}</Th>
        </tr>
        {data.map((field, index) => {
          const details = field.offerDetails;
          const rowSpan = details.length; // always >= 1

          return details.map((detail, detailIndex) => (
            <tr>
              {detailIndex === 0 && (
                <>
                  <Td rowSpan={rowSpan}>{field.offerCode}</Td>
                  {/* <Td rowSpan={rowSpan}>
                    {locale === 'en-US'
                      ? field.descriptionEn
                      : field.descriptionFr}
                  </Td> */}
                </>
              )}

              {/* One row per offer detail */}
              <Td>{locale === 'en-US' ? detail.offerDetailsEn : detail.offerDetailsFr}</Td>
              <Td>
                {detail.frequency === 'monthly'
                  ? formatCurrency(detail.value)
                  : formatCurrency(0)}
              </Td>
              <Td>
                {detail.frequency === 'oneTime'
                  ? formatCurrency(detail.value)
                  : formatCurrency(0)}
              </Td>
              {detailIndex === 0 && (
                <>
                  <Td rowSpan={rowSpan}>
                    <IconButton
                      icon={DeleteIcon}
                      onPress={e => deleteItem(e, index)}
                      accessibilityLabel="Delete"
                    />
                  </Td>
                </>
              )}
            </tr>
          ));
        })}
        <tr>
          <Td bold textAlign="center" colSpan={2}>
            Total Charges
          </Td>
          <Td bold>{formatCurrency(monthlyCharges)}</Td>
          <Td bold>{formatCurrency(oneTimeCharges)}</Td>
          <Td></Td>
        </tr>
      </table>
    </>
  );
};

export default tableForCouponCodeOffer;
